module.exports = __webpack_public_path__ + "img/KSC02653.e933cc1e.jpg";